import { createAppAsyncThunk } from '../appAsyncThunk';
import { history } from '../../router/BrowserRouter';
import { setIsLoggedIn } from './slice';
import { SignIn, UpdatePassword } from './types';
import {
    signIn,
    signOut,
    getCurrentUser,
    updatePassword,
} from 'aws-amplify/auth';

export const signInThunk = createAppAsyncThunk(
    'auth/signInThunk', async ({ username, password, from }: SignIn, { dispatch, rejectWithValue }) => {
        try {
            const response = await signIn({ username, password });

            if (response.isSignedIn) {
                localStorage.setItem('auth_status', 'Authenticated');
                dispatch(setIsLoggedIn(true));
                history.push(from || '/workspace');
                dispatch(getUserInfoThunk());
                return response.isSignedIn;
            } else {
                return rejectWithValue('Incorrect username or password');
            }
        } catch (e: unknown) {
            if (e instanceof Error) {
                return rejectWithValue(e.message);
            } else {
                return rejectWithValue('An error occurred, Try again later');
            }
        }
    });

export const getUserInfoThunk = createAppAsyncThunk(
    'auth/getUserInfoThunk', async () => {
        const { userId } = await getCurrentUser();
        return userId;
    });

export const changePasswordThunk = createAppAsyncThunk(
    'auth/changePasswordThunk', async (body: UpdatePassword) => {
        const response = await updatePassword(body);
        return response;
    });

export const logOutThunk = createAppAsyncThunk(
    'auth/logOutThunk', async () => {
        const response = await signOut();
        return response;
    });